class SearchFiltersModal {
  constructor(context, settings, $, debounce) {
    this.element = document.querySelector(".c-search-filters-modal");
    if (this.element === null) {
      return;
    }
    this.phabletSize = 900;
    this.body = document.querySelector("body");
    this.header = document.querySelector(".c-header");
    this.modal = document.querySelector(".c-search-filters-modal__modal");
    const openButton = this.element.querySelector(
      ".c-search-filters-modal__open-button"
    );

    if (openButton) {
      openButton.addEventListener("click", () => this.showModal());
    }

    const closeButton = this.element.querySelector(
      ".c-search-filters-modal__close-button"
    );
    if (closeButton) {
      closeButton.addEventListener("click", () => this.hideModal());
    }


    window.addEventListener(
      "resize",
      debounce((e) => {
        if (window.innerWidth > this.phabletSize) {
          this.hideModal();
        }
      }, 300)
    );
  }

  showModal() {
    if (!this.body.classList.contains("no-scroll")) {
      this.body.classList.add("no-scroll");
    }

    if (!this.modal.classList.contains("open")) {
      this.modal.classList.add("open");
    }

    if(this.header){
      this.header.style.zIndex = 4; 
    }
  }

  hideModal() {
    this.body.classList.remove('no-scroll');
    this.modal.classList.remove("open");

    if(this.header){
      this.header.style.zIndex = 5;
    }
  }
}

export default SearchFiltersModal;
